import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { AuditIcon } from '../../components/AuditIcon';
import { AuditConfigForm } from './form';
import { ReportDefinitions } from './ReportDefinitions';
export const AuditConfigPage = () => {
  const { $t } = useIntl();
  const title = $t({
    id: 'audit.configScreen.title',
    defaultMessage: 'Audit config',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<AuditIcon />}
        title={[
          $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
          title,
        ]}
      />
      <Page.Content>
        <Stack spacing={2}>
          <ReportDefinitions />
          <AuditConfigForm />
        </Stack>
      </Page.Content>
    </Page>
  );
};
